export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATIONS_SUCCEED = 'FETCH_NOTIFICATIONS_SUCCEED';
export const FETCH_NOTIFICATIONS_FAILED = 'FETCH_NOTIFICATIONS_FAILED';

export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS';
export const ADD_NOTIFICATIONS_SUCCEED = 'ADD_NOTIFICATIONS_SUCCEED';
export const ADD_NOTIFICATIONS_FAILED = 'ADD_NOTIFICATIONS_FAILED';

export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';
export const UPDATE_NOTIFICATIONS_SUCCEED = 'UPDATE_NOTIFICATIONS_SUCCEED';
export const UPDATE_NOTIFICATIONS_FAILED = 'UPDATE_NOTIFICATIONS_FAILED';

export const DELETE_NOTIFICATIONS = 'DELETE_NOTIFICATIONS';
export const DELETE_NOTIFICATIONS_SUCCEED = 'DELETE_NOTIFICATIONS_SUCCEED';
export const DELETE_NOTIFICATIONS_FAILED = 'DELETE_NOTIFICATIONS_FAILED';
